import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { api } from '../utils/api';
import { FASTIFY_BASE_URL } from '../config/apiConfig';

// Fire the PostHog org-identify at most once per session (guards remounts as the
// user navigates between dashboard sub-routes).
let orgIdentifyFired = false;

export function usePosthogOrgIdentify() {
  const posthog = usePostHog();

  // Sync the current user's organization data to PostHog person properties on
  // dashboard load — replaces scripts/sync_users_to_posthog.py so we never run a
  // batch sync again. Fire-and-forget; the backend resolves identity from auth.
  useEffect(() => {
    if (orgIdentifyFired) return;
    orgIdentifyFired = true;
    // Send an explicit {} body — fastify rejects an empty application/json body.
    api.post(`${FASTIFY_BASE_URL}/posthogIdentify`, {})
      .then((res) => {
        if (res?.data?.success === false) {
          // The server skipped the sync (e.g. PostHog key not configured on
          // the API host) — surface it instead of failing silently: org-gated
          // feature flags will NOT match this user until the sync works.
          console.warn('PostHog organization identify was skipped by the server:', res?.data?.reason || 'unknown');
          return;
        }
        // Deterministic same-session flags — including the user's FIRST EVER
        // login: the server's $set lands via PostHog's async ingestion
        // pipeline, so a plain flag reload could still race it. The route
        // echoes the exact properties it sent; overriding them client-side
        // makes every flag evaluation carry them immediately (and triggers a
        // reload), no ingestion wait.
        const properties = res?.data?.properties;
        if (properties && posthog?.setPersonPropertiesForFlags) {
          posthog.setPersonPropertiesForFlags(properties);
        } else {
          posthog?.reloadFeatureFlags?.();
        }
      })
      .catch((error) => {
        orgIdentifyFired = false; // let the next dashboard load retry
        console.warn('PostHog organization identify failed.', error);
      });
  }, [posthog]);
}
